export default __webpack_public_path__ + "static/topography-rectangle-723acf3521a79170cd7d7179d3173017.jpg";